/* 🤖 this file was generated by svg-to-ts */
export const iccIconExpandLess: {
  name: 'expand_less';
  data: string;
} = {
  name: 'expand_less',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12 8.295-6 6 1.41 1.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6Z" fill="currentColor"/></svg>`
};
